import React from "react";
import { cn } from "@/lib/utils";

interface ShinyTextProps {
    text: string;
    speed?: number;
    color?: string;       // The base text color (e.g., slate/gray)
    shineColor?: string;  // The glowing highlight color
    pauseOnHover?: boolean;
    disabled?: boolean;
    className?: string;
}

export default function ShinyText({
    text,
    speed = 3,
    color = "currentColor",
    shineColor = "hsl(var(--foreground))",
    pauseOnHover = false,
    disabled = false,
    className,
}: ShinyTextProps) {

    if (disabled) {
        return <span className={className} style={{ color }}>{text}</span>;
    }

    // Uses inline styling just for the dynamic gradient colors to keep it flexible
    const shineStyle: React.CSSProperties = {
        backgroundImage: `linear-gradient(to right, transparent 0%, ${shineColor} 50%, transparent 100%)`,
        backgroundSize: "200% 100%",
        color,
        WebkitBackgroundClip: "text",
        backgroundClip: "text",
        WebkitTextFillColor: "transparent",
        animationDuration: `${speed}s`,
    };

    return (
        <span
            className={cn(
                "inline-block font-bold tracking-tight",
                // Auto-switches direction based on document language (RTL for Arabic, LTR for English)
                "ltr:animate-text-shine rtl:animate-text-shine-rtl",
                // Accessibility: stop animation if the user prefers reduced motion
                "motion-reduce:animate-none motion-reduce:bg-[length:100%]",
                // Handle pause on hover using pure CSS
                pauseOnHover && "hover:[animation-play-state:paused]",
                className
            )}
            style={shineStyle}
        >
            {text}
        </span>
    );
}
